export default "__VITE_ASSET__5d7b885d__"